import { makeObservable, observable, action, reaction,toJS,when } from 'mobx';
import qs from 'qs';
// import History from 'mobx-history-api'
import { history, stores } from "../../history_mobx";

class memoryStore {
  route="";
  history=null;
  memory={};
  memory_str="";
  // location={};
  allow_memory_save=["order","filter","items_per_page","page"];
  reactions=[];

  par=null;
  constructor(par, localMemory) {
    this.par=par;
    makeObservable(this,{
      route:observable,
      memory:observable,
      memory_str:observable,
      // location:observable,
    });
    // this.location=history.location;
 /*   history.listen((location)=>{
      this.location=location;
    });*/

    reaction(()=>{ return stores.router.location.search; },(search)=>{
      console.log("LOCATION BIND",search);
    });

    if(localMemory) {

      /*reaction(() => {
        return this.memory_str;
      }, (str) => {
        console.log('memory react', str);
        this.history.push(this.history.path + "?" + str);
      })*/

    } else {
      // this.history = new History();

      when(
        ()=>{ return this.par.configStore.config.data.layout_marker; },
        ()=>{

          const loaded=this.loadFromLocalStorage();
          if(loaded) {
            // this.history.replace(this.history.path+"?"+loaded);
            history.replace(stores.router.location.pathname+"?"+loaded);
            console.log("loadFromLocalStorage REP",stores.router.location.pathname+"?"+loaded);
            // this.router.replace();
          }

          this.reactions.push(reaction(() => {
            return this.memory.iframe;
          },(iframe) => {
            if(iframe && !window.onIframeAction) {
              window.onIframeAction=(j)=> {
                if (j.answer.button == "apply") {
                  return false;
                }
                if (j.answer.button == "cancel" || j.answer.button == "submit" || j.answer.button == "delete") {
                  this.memory.iframe = null;
                  this.buildMemory();
                  return true;
                }
              };
            }
          }, { fireImmediately: true }));
          this.reactions.push(reaction(() => {
            return this.memory_str;
          }, (str) => {
            if(typeof str !== "undefined" && str!=stores.router.location.search.substr(1)) {
              this.saveToLocalStorage(str);
              history.push(stores.router.location.pathname + "?" + str);
            }
          }));

          this.reactions.push(reaction(() => {
            // return this.history.url;
            return stores.router.location;
          }, (loc) => {
            if(!this.par.configStore.config.data.pathname_only || this.par.configStore.config.data.pathname_only === loc.pathname) {
              const data = loc.search;

              const ex = data.split('?');
              const parsed = qs.parse(ex[1]);
              if (!parsed.items_per_page) {
                // parsed.items_per_page = 20;
              }
              console.log('history url changed', parsed)
              this.memory = parsed;
              this.memory_str = ex[1];
              if (this.par.communicatorStore) {
                this.par.communicatorStore.pushMessage({
                  type: "output",
                  command: "history_changed",
                  data: {memory: parsed}
                })
              }
            }
          }, {
            fireImmediately: true
          }));
        }
      );
    }
  }
  destroy() {
    for(let i in this.reactions) {
      this.reactions[i]();
    }
  }
  loadFromLocalStorage() {
    if(typeof localStorage !== 'undefined') {
      const marker = this.par.configStore.config.data.layout_marker;
      let loaded=localStorage.getItem(`eva_layout_${marker}`);
      const loadedParsed=qs.parse(loaded);

      // const ex = this.history.url.split('?');
      // const newLoaded = qs.parse(ex[1]);
      return false;
      let newLoaded={};
      if(stores.router.location.search) {
        newLoaded = qs.parse(stores.router.location.search.substr(1));
      }
      for(let i in this.allow_memory_save) {
        if(loadedParsed[this.allow_memory_save[i]] && !newLoaded[this.allow_memory_save[i]]) {
          newLoaded[this.allow_memory_save[i]]=loadedParsed[this.allow_memory_save[i]];
        }
      }
      return qs.stringify(newLoaded);
    }
  }
  saveToLocalStorage(str) {
    console.log('saveToLocalStorage',str);
    if(typeof localStorage !== 'undefined') {
      console.log('saveToLocalStorage','SAVE');
      const marker=this.par.configStore.config.data.layout_marker;
      localStorage.setItem(`eva_layout_${marker}`,str);
    }
  }
  getOrder(varName) {
    if(this.memory.order) {
      if(this.memory.order[varName]) {
        return this.memory.order[varName];
      }
      return false;
    } else {
      const def=this.par.configStore.config.data.default_order;
      if(def[varName]) {
        return def[varName];
      }
    }
    return false;
  }
  setItemsPerPage(num) {
    this.memory.items_per_page = num;
    this.memory_str=qs.stringify(this.memory);
  }
  setPage(num) {
    this.memory.page = num;
    this.memory_str=qs.stringify(this.memory);
  }
  setFilter(arr,firstTime=true) {
    this.memory.filter=arr;
    if(!firstTime) {
      delete this.memory.page;
    }
    this.memory_str=qs.stringify(this.memory);
  }
  setOrder(varName,toWhat='toggle') {
    const def=this.par.configStore.config.data.default_order;
    if(toWhat == 'toggle') {
      let setTo='asc';
      if(this.memory.order) {
        if (this.memory.order[varName] === 'asc') {
          setTo = 'desc';
        }
        if(def && def[varName] == setTo) {
          this.memory.order={};
        } else {
          if (this.memory.order[varName]) {
            this.memory.order[varName] = setTo;
          } else {
            this.memory.order = {[varName]: setTo};
          }
        }
      } else {
        if(def && def[varName] == setTo) {
          this.memory.order={};
        } else {
          this.memory.order={[varName]:setTo};
        }

      }
    } else {
      if(def && def[varName] == toWhat) {
        this.memory.order={};
      } else {
        this.memory.order = {[varName]: toWhat};
      }
    }
    delete this.memory.page;
    this.memory_str=qs.stringify(this.memory);
  }
  buildMemory() {
    this.memory_str=qs.stringify(this.memory);
  }
  getSelect() {
    // const data=toJS(this.memory);
    const select=toJS(this.par.configStore.config.data.layout);

    for(let i in select) {
      const field=this.par.configStore.fields_by_code[select[i]];
      if(field && field.need_select) {
        for(let j in field.need_select) {
          select.push(field.need_select[j]);
        }
      }
    }

    return select;
  }
  getRequest() {
    const data=toJS(this.memory);
    const allow=['filter','page','order'];
    for(let i in data) {
      if(allow.indexOf(i) < 0) {
        delete data[i];
      }
    }
    /*data.select=toJS(this.par.configStore.config.data.layout);

    for(let i in data.select) {
      const field=this.par.configStore.fields_by_code[data.select[i]];
      if(field && field.need_select) {
        for(let j in field.need_select) {
          data.select.push(field.need_select[j]);
        }
      }
    }*/

    data.select=this.getSelect();

    data.detail_url=this.par.configStore.config.data.detail_url;
    if(!data.items_per_page) {
      data.items_per_page = 20;
    }
    if(!data.page) {
      data.page=1;
    }
    data.generate_pages={
      variable:'page',
      // url:this.history?this.history.url:'',
      // url:stores.router.location?(stores.router.location.pathname+stores.router.location.search):'',
    }
    data.filter=this.par.searchStore.getFilter();
    if(this.par.configStore.config.data.system_filter) {
      data.system_filter=this.par.searchStore.getFilter(this.par.configStore.config.data.system_filter);
    }

    if(data.type) {
      delete data.type;
    }
    if(data.operation) {
      delete data.operation;
    }
    if(Object.keys(data.filter).length === 0) {
      delete data.filter;
    }
    return {
      url:this.par.configStore.config.data.data_route,
      data:data,
    };

  }
}

export default memoryStore;
